module.exports = __webpack_public_path__ + "static/media/Iris Street, San Francisco, CA17.22b56118.jpg";